import script from "./ScopesCircleChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ScopesCircleChart.vue?vue&type=script&setup=true&lang=js"

import "./ScopesCircleChart.vue?vue&type=style&index=0&id=d4bcfeb6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4bcfeb6"]])

export default __exports__